import { createAction } from '@reduxjs/toolkit';

import { SurveyValueExcelFailure } from '../../types/entity.types';
import { SagaPayload } from '../api.types';
import { UploadSurveyRequest } from './survey.types';

export const requestUploadSurvey =
  createAction<SagaPayload<UploadSurveyRequest, undefined, SurveyValueExcelFailure[]>['payload']>(
    'request/uploadSurvey'
  );
